import { TagFragment } from '~/graphql/fragments'
import {
  SectionAbout,
  SectionAboutPage,
  SectionArticles,
  SectionAwards,
  SectionCanvas,
  SectionClients,
  SectionContactForm,
  SectionCta,
  SectionFacts,
  SectionFaq,
  SectionFeatures,
  SectionGames,
  SectionHero,
  SectionImageGallery,
  SectionJobs,
  SectionLetsTalk,
  SectionLogos,
  SectionMedia,
  SectionMediaLarge,
  SectionNewsletterSubscription,
  SectionNumbers,
  SectionProjects,
  SectionRelatedArticles,
  SectionServices,
  SectionStatement,
  SectionStructuredText,
  SectionTeam,
  SectionTeaser,
  SectionTestimonials,
  SectionVideo,
  SectionWorks,
  SectionContactUs
} from '~/graphql/sections'
import { graphql } from '~/lib/datocms/graphql'

export const queryPage = graphql(
  /* GraphQL */ `
    query Page($slug: String) {
      page(filter: { slug: { eq: $slug } }) {
        _seoMetaTags {
          ...TagFragment
        }
        _modelApiKey
        id
        slug
        title
        colorTheme
        modules {
          ... on RecordInterface {
            id
            __typename
          }
          ...SectionAbout
          ...SectionAboutPage
          ...SectionArticles
          ...SectionAwards
          ...SectionCanvas
          ...SectionClients
          ...SectionContactForm
          ...SectionCta
          ...SectionFacts
          ...SectionFaq
          ...SectionFeatures
          ...SectionGames
          ...SectionHero
          ...SectionImageGallery
          ...SectionJobs
          ...SectionLetsTalk
          ...SectionLogos
          ...SectionMedia
          ...SectionMediaLarge
          ...SectionNewsletterSubscription
          ...SectionNumbers
          ...SectionProjects
          ...SectionRelatedArticles
          ...SectionServices
          ...SectionStatement
          ...SectionStructuredText
          ...SectionTeam
          ...SectionTeaser
          ...SectionTestimonials
          ...SectionVideo
          ...SectionWorks
          ...SectionContactUs
        }
      }
    }
  `,
  [
    TagFragment,
    SectionAbout,
    SectionAboutPage,
    SectionArticles,
    SectionAwards,
    SectionCanvas,
    SectionClients,
    SectionContactForm,
    SectionCta,
    SectionFacts,
    SectionFaq,
    SectionFeatures,
    SectionGames,
    SectionHero,
    SectionImageGallery,
    SectionJobs,
    SectionLetsTalk,
    SectionLogos,
    SectionMedia,
    SectionMediaLarge,
    SectionNewsletterSubscription,
    SectionNumbers,
    SectionProjects,
    SectionRelatedArticles,
    SectionServices,
    SectionStatement,
    SectionStructuredText,
    SectionTeam,
    SectionTestimonials,
    SectionTeaser,
    SectionVideo,
    SectionWorks,
    SectionContactUs
  ]
)
